<template>
  <div class="space"></div>
  <div class="container conts">
    <div class="row">
      <div class="col"></div>
      <div class="col-sm-9">
        <div class="recuadro bg-white mt-5 mb-5">
          <div class="text-center head bg-primary bg-gradient text-white p-4">
            <h1>REGISTRO CONTADOR SMART</h1>
            <p>POR FAVOR COMPLETA ESTOS DATOS PARA QUE PODAMOS REGISTRARTE COMO CONTADOR SMART</p>
          </div>
          <div class="card-body p-5">
            <form action="/registrar-contador" method="POST">
              <div class="row mb-3">
                <div class="col-sm-4">
                  <label for="user" class="form-label form-control-lg">Coloque su DNI</label>
                </div>
                <div class="col-sm-8">
                  <div class="input-group">
                    <input type="text" class="req form-control form-control-lg" name="b_dni" id="b_dni"
                      v-model="contador.documento" v-bind:class="{ 'invalid': errores.documento }" @keyup.enter="btnBuscar_click">
                    <button class="btn btn-primary btn-lg" type="button" id="button-addon2" @click="btnBuscar_click" ><i class="fas fa-search"></i>
                      Buscar</button>
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-sm-4">
                  <label for="user" class="form-label form-control-lg">Nombre Completo</label>
                </div>
                <div class="col-sm-8">
                  <div class="input-group">
                    <input type="text" class="req form-control form-control-lg"
                    v-model="contador.nombre" v-bind:class="{ 'invalid': errores.nombre }" disabled>
                  </div>
                </div>
              </div>
            </form>
            <form id="regis" action="/registrarRecomendador" method="POST">
              <input type="hidden" name="id_cont" id="id_cont" value="<%= (contador) ? contador.id_cont : '' %>">
              <input type="hidden" name="cont_nombre" id="cont_nombre"
                value="<%= (contador) ? contador.cont_nombre : '' %>">
              <input type="hidden" name="cont_asesor" id="cont_asesor"
                value="<%= (contador) ? contador.cont_asesor : '' %>">
              <input type="hidden" name="cont_ocupacion" id="cont_ocupacion" value="Contador">
              <div class="mb-3 bg-light p-3 rounded-3">
                <div class="row">
                  <div class="col">
                    <label for="ciudad" class="form-control-lg">Ciudad</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" name="cont_ciudad" id="cont_ciudad"
                      maxlength="50" v-model="contador.ciudad" v-bind:class="{ 'invalid': errores.ciudad }">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="rev_nombre" class="form-control-lg">Dirección</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" name="cont_direccion" id="cont_direccion"
                      maxlength="255" v-model="contador.direccion" v-bind:class="{ 'invalid': errores.direccion }">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="rev_nombre" class="form-control-lg">Teléfono</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" name="cont_telefono" id="cont_nombre"
                      maxlength="20" v-model="contador.telefono" v-bind:class="{ 'invalid': errores.telefono }">
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <label for="rev_nombre" class="form-control-lg">E-mail</label>
                  </div>
                  <div class="col-sm-7">
                    <input type="text" class="req form-control form-control-lg" name="cont_email" id="cont_email"
                      maxlength="50" v-model="contador.correo" v-bind:class="{ 'invalid': errores.correo }">
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="input-group mb-3">
                  <input type="hidden" name="cont_terminos" id="cont_terminos" value="N">
                  
                  <i id="icon" class="btnchk check-icon check-45 far"
                  v-bind:class="{ 'fa-square': !checkTerminos, 'fa-check-square': checkTerminos }"
                  @click="checkTerminos = !checkTerminos"></i>
                  <label for="cont_terminos" class="form-control-lg">
                    <p>Acepto términos y condiciones</p>
                  </label>
                  <a href="https://smartregistro.s3.us-west-2.amazonaws.com/Terminos%20y%20condiciones%20SMARTCLIC%20%28contadores%20y%20revendedores%20SMART%29.pdf"
                    class="form-control-lg" target="_blank">VER TERMINOS Y CONDICIONES</a>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <input type="hidden" name="cont_fec_registro" id="cont_fec_registro">
                  <div class="col"></div>
                  <div class="col"></div>
                  <div class="col"><button type="button" id="guardar" class="btn btn-primary form-control btn-lg"
                      @click="btnGuardar_click" :disabled="!checkTerminos">Guardar</button></div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col"></div>
    </div>
  </div>
</template>
<script>
import ClientesService from '@/services/clientes.service';
import Utils from '@/functions/utils';
import { EstadoContador, EstadoRegistro } from '@/constants/global';
import spinnerService from '@/services/spinner.service';

export default {
  data() {
    return {
      loading: false,
      checkTerminos: false,
      errores: {},
      contador: {},
      contadordb: null
    }
  },
  methods: {
    async btnBuscar_click() {
      if (this.loading) return;
      this.errores.documento = this.contador.documento == null || this.contador.documento.trim() == '';
      let existError = Object.keys(this.errores).some(key => this.errores[key]);
      if (existError) {
        Utils.mostrarMensajeError('Por favor, ingrese el número de DNI')
        return;
      }
      this.loading = true;
      spinnerService.show();
      try {
        let res = await ClientesService.getContadorPorDocumento(this.contador.documento);
        this.loading = false;
        if (res == null) {
          Utils.mostrarMensajeError('El DNI ingresado no está registrado')
          return;
        }
        if (res.ocupacion != 'Contador') {
          Utils.mostrarMensajeErrorConTitulo('No Autorizado','El DNI ingresado no está registrado')
          return;
        }
        this.contadordb = res;
        this.contador.nombre = res.razonSocial;
      } catch (error) {
        this.loading = false;
        Utils.mostrarMensajeError(error.Message || 'Ocurrio un error')
      } finally{
        spinnerService.hide();
      }

    },
    async btnGuardar_click(){
      if (this.loading) return;
      //VALIDACIONES
      this.errores.contador = this.contadordb == null;
      this.errores.documento = this.contador.documento == null || this.contador.documento.trim() == '';
      this.errores.nombre = this.contador.nombre == null || this.contador.nombre.trim() == '';
      this.errores.direccion = this.contador.direccion == null || this.contador.direccion.trim() == '';
      this.errores.telefono = this.contador.telefono == null || this.contador.telefono.trim() == '';
      this.errores.ciudad = this.contador.ciudad == null || this.contador.ciudad.trim() == '';
      this.errores.correo = this.contador.correo == null || this.contador.correo.trim() == '';
      if (this.errores.contador) {
        Utils.mostrarMensajeAdvertencia('Ingrese datos de contador')
        return;
      }
      let existError = Object.keys(this.errores).some(key => this.errores[key]);
      if (existError) return;

      this.loading = true;
      spinnerService.show();
      try {
        let obj = {
          Id: this.contadordb.id,

          Telefono: this.contador.telefono,
          Ciudad: this.contador.ciudad,
          Direccion: this.contador.direccion,
          Correo: this.contador.correo,
          IdAsesor: (this.contadordb && this.contadordb.idAsesor) || 0,
          Ocupacion: 'Contador',
          Estado: EstadoContador.REGISTRADO,
          FechaRegistro: new Date(),
          Terminos: this.checkTerminos ? 1 : 0,

          
          Documento: this.contadordb.documento,
          RazonSocial: this.contadordb.razonSocial,
          Confirmacion: this.contadordb.confirmacion,
          FechaConfirmacion: this.contadordb.fechaConfirmacion,
          FechaCreacion: this.contadordb.fechaCreacion,
          Afiliado: this.contadordb.afiliado,
          LogEstado: EstadoRegistro.ACTIVO
        };

        await ClientesService.updateContador(obj.Id,obj);
        Utils.mostrarMensajeExito('El contador se ha guardado exitosamente');
        this.loading = false;
        this.$router.push({
          path: `/felicidades-contador`
        });
      } catch (error) {
        this.loading = false;
        Utils.mostrarMensajeAdvertencia(error.Message || 'Ocurrio un error')
      } finally{
        spinnerService.hide();
      }
    }
  }
}
</script>